import {VStack, Text} from "@chakra-ui/react";

export function About() {
    return (
        <VStack
            spacing="16px"
            marginTop={["32px", "48px", "64px"]}
            marginBottom={["32px", "48px", "64px"]}
            marginLeft={["4%", "10%", "16%", "22%"]}
            marginRight={["4%", "10%", "16%", "22%"]}
            align="left"
        >
            <Text
                fontSize={["3xl", "4xl", "5xl"]}
                fontWeight="bold"
                color="red"
            >
                About
            </Text>
            <Text
                fontSize="lg"
            >
                Mafia: The Game was a free online game based on the party game Mafia (also known as Werewolf). It was a great
                game to play as an ice-breaker or with friends over a video call.
            </Text>
            <Text
                fontSize="lg"
            >
                The game has now been discontinued. Thank you to all who played and enjoyed it.
            </Text>
        </VStack>
    );
}